import { render, staticRenderFns } from "./AssetGroupsPage.vue?vue&type=template&id=2595c1b2"
import script from "./AssetGroupsPage.vue?vue&type=script&lang=js"
export * from "./AssetGroupsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports